export function storeToken(email, token) {
    window.sessionStorage.setItem(`inbox_${email}`, token);
}
